import { useMemo } from "react"
import { useSelector } from "react-redux"

import MajorMedDepartmentDrawerServiceItem from "./MajorMedDepartmentDrawerServiceItem"
import { MajorMedDepartmentDrawerSurgicalItem } from "./MajorMedDepartmentDrawerSurgicalItem"

import classes from './MajorMedDepartment.module.css'

export default function MajorMedDepartmentDrawer({departmentId, majorMedData, showInactive}) {   

    const activeCase = useSelector(state => state.case.activeCase)
    const surgeries = activeCase?.surgeries ?? []
    const relatedServices = useMemo(() => {
        if (!departmentId) {
            return []
        }
        const services = activeCase?.services ?? []
        return services.filter((element) => element.department_id === departmentId)
    }, [departmentId, activeCase?.services])
    const filteredRelatedServices = useMemo(() => (
        relatedServices.filter((item) => (showInactive ? !item.completed_date : true))
    ), [relatedServices, showInactive])

    return <div>
        {departmentId !== 5 && <>
            {relatedServices.length > 0 && <div className={classes.drawer_container}>
                <table>
                    <thead>
                        <tr>
                            <td style={{width: 360}}>Services</td>
                            {(departmentId === 1 || departmentId === 2) && <td>No. of visits</td>}
                            <td style={{width: 100}}>Status</td>
                            <td>Auth Number</td>
                            <td>Auth Date</td>
                            <td>Final Verification Completed</td>
                            <td>CoPay/CoIns</td>
                            <td>Deductibles</td>
                            <td>Paid</td>
                            <td>Payment Plan</td>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredRelatedServices.map(item => (
                            <MajorMedDepartmentDrawerServiceItem key={item.id} serviceItem={item} departmentId={departmentId} majorMedData={majorMedData}/>
                        ))}  
                    </tbody>
                </table>
                
            </div>}
            {relatedServices.length === 0 && <p>There are no services for this department!</p>}
        </>}
        
        {departmentId === 5 && <>
            {surgeries.length > 0 &&<div className={classes.drawer_container}>
                <table>
                    <thead>
                        <tr>
                            <td style={{width: 360}}>Surgeries</td>
                            <td style={{width: 100}}>Status</td>
                            <td>Auth Number</td>
                            <td>Auth Date</td>
                            {/* <td>Auth Exp. Date</td> */}
                            <td>Final Verification Completed</td>
                            <td>CoPay/CoIns</td>
                            <td>Deductibles</td>
                            <td>Paid</td>
                            <td>Payment Plan</td>
                        </tr>
                    </thead>
                    <tbody>
                {surgeries.map(item => (
                    <MajorMedDepartmentDrawerSurgicalItem key={item.id} surgicalItem={item} departmentId={departmentId} majorMedData={majorMedData}/>
                ))}
                    </tbody>
                </table>
                
            </div>}
            {surgeries.length === 0 && <p>There are no surgeries!</p>}
        </>}
    </div>
}